import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router-dom";
import DataTable, { DATA_TABLE_TYPES } from "../../components/Table/DataTable";
import { toPaymentGatewayOptions, uid } from "../../helper";
import { useModal } from "../../hooks/useModal";
import TableAction from "../../components/Table/TableAction";
import { DATA_TABLE_FILTER } from "../../components/Table/FilterPopup";
import PaymentsService from "../../services/payments.service";
import { useApp } from "../../hooks/useApp";
import { PaymentStatus } from "./PaymentStatus";
import PlansService from "../../services/plan.service";
import { DataLoading } from "../../components/PreLoader/PreLoader";
import { Amount } from "../../components/General/Amount";
import { USDTPaymentView } from "./USDTPaymentView";
import { DebitPaymentView } from "./DebitPaymentView";
import { ROUTES } from "../../services/constants";

const Payments = ({title, status, method}) => {
    const {t} = useTranslation();
    const {setPageTitle} = useOutletContext();
    const {openModal} = useModal();
    const {paymentGateways} = useApp();
    const [plans, setPlans] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    let defaultFilterConfig = {};
    if(status)
        defaultFilterConfig['status'] = status;
    if(method)
        defaultFilterConfig['payment_gateway'] = method;
    useEffect(() => {
        PlansService.listAsOptions().then((data) => {
            setPlans(data);
            setIsLoading(false);
        })
    }, [])
    const columns = [
        { 
            key: "id",
            label: "#",
            sort: true
        },
        { 
            key: "uid", 
            label: t("Account Number"), 
            render: (row) => uid(row.uid), 
            filter: DATA_TABLE_FILTER.INPUT,
            sort: true,
            to: (row) => (`${ROUTES.ACCOUNT_DASHBOARD.replace(':uid', row.uid)}`)
        },
        { 
            key: "order_id", 
            label: t("Invoice Number"), 
            render: (row) => (row.order.order_id),
            filter: DATA_TABLE_FILTER.INPUT,
            to: (row) => (`${ROUTES.INVOICES}?order_id=${row.order.order_id}`)
        },
        { 
            key: "payment_gateway", 
            label: t("Method"),
            sort: true,
            render: (row) => (<b>{paymentGateways?.[row.payment_gateway]}</b>),
            filter: DATA_TABLE_FILTER.CHOOSE_OPTIONS,
            options: toPaymentGatewayOptions(paymentGateways)
        },
        { 
            key: "plan_id", 
            label: t("Plan"),
            sort: true,
            render: (row) => (<>{row.order.plan.name?.['en']}</>),
            filter: DATA_TABLE_FILTER.CHOOSE_OPTIONS,
            options: plans
        },
        { 
            key: "amount", 
            label: t("Amount"),
            sort: true,
            render: (row) => (<Amount currency={row.order.currency} amount={row.order.price} />)
        },
        { 
            key: "created_at", 
            label: t("Payment Time"), 
            type: DATA_TABLE_TYPES.DATE_TIME,
            sort: true,
            filter: DATA_TABLE_FILTER.DATE_RANGE
        },
        { 
            key: "status", 
            label: t("Status"), 
            render: (row) => <PaymentStatus row={row} label={true}/>,
            filter: DATA_TABLE_FILTER.CHOOSE_OPTIONS,
            options: [
                { key: "0", value: t("Pending") }, 
                { key: "1", value: t("Successfulll") }, 
                { key: "2", value: t("Unsuccessfull") },
                { key: "3", value: t("Declined") }
            ]
        }
        

    ]
    useEffect(() => { 
        setPageTitle(title??t("Waiting for approvals payments"));
    }, [setPageTitle]);
    const onClickView = (context, data) => {
        if(paymentGateways?.[data.payment_gateway] === 'USDT')
            openModal(<USDTPaymentView context={context} data={data} />)
        else
            openModal(<DebitPaymentView context={context} data={data} />)
    }
    return (
        <>
            {isLoading?(
                <DataLoading small={true} />
            ):(
                <DataTable 
                    columns={columns} 
                    fetcher={PaymentsService.list}
                    searchPlaceholder={t("Search by Account Number or Invoice Number or Customer Name or E-Mail...")}
                    defaultFilterConfig={defaultFilterConfig}
                    actions={(data, context) => {
                        return (
                            <>
                                <TableAction onClick={(e) => onClickView(context, data)}>{t("View")}</TableAction>
                            </>
                        )
                    }}
                />
            )}
            
        </>
    )
}
export default Payments;